import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import { reportFunctionError } from 'src/utilities/sentry';
import { BankAccountData } from '../types';
import { ACTION_TYPES } from './types';

export type BankAccountState = {
  data: BankAccountData;
  loading: boolean;
  inquirySuccess: boolean;
  error: string;
};

const initialState: BankAccountState = {
  data: {
    account_number: '',
    bank_code: '',
    account_name: '',
  },
  loading: false,
  inquirySuccess: false,
  error: '',
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.BANK_ACCOUNT_INQUIRY:
      return update(state, {
        $merge: {
          error: '',
          inquirySuccess: false,
        },
      });

    case ACTION_TYPES.BANK_ACCOUNT_INQUIRY_SUCCESS:
      if (payload.success) {
        return update(state, {
          $merge: {
            data: payload.data,
            inquirySuccess: true,
          },
        });
      }

      return update(state, {
        $merge: {
          error: payload.error.message,
          inquirySuccess: true,
        },
      });

    case ACTION_TYPES.BANK_ACCOUNT_INQUIRY_FAILED:
      reportFunctionError({
        domain: 'dashboard',
        message: 'Failed to load inquiry bank account (API Call)',
        name: 'loadInquiry',
        exception: payload,
        parentName: 'BankAccount',
      });
      return update(state, {
        $merge: {
          error: payload.response.data,
          inquirySuccess: false,
        },
      });

    case ACTION_TYPES.BANK_ACCOUNT_GET:
      return update(state, {
        $merge: {
          error: '',
        },
      });

    case ACTION_TYPES.BANK_ACCOUNT_GET_SUCCESS:
      return update(state, {
        $merge: {
          data: payload.data,
        },
      });

    case ACTION_TYPES.BANK_ACCOUNT_GET_FAILED:
      reportFunctionError({
        domain: 'dashboard',
        message: 'Failed to get bank account (API Call)',
        name: 'getAccountBankData',
        exception: payload,
        parentName: 'BankAccount',
      });
      return update(state, {
        $merge: {
          error: payload.response.data,
        },
      });

    case ACTION_TYPES.BANK_ACCOUNT_UPDATE:
      return update(state, {
        $merge: {
          loading: true,
          error: '',
        },
      });

    case ACTION_TYPES.BANK_ACCOUNT_UPDATE_SUCCESS:
      return update(state, {
        loading: {
          $set: false,
        },
      });

    case ACTION_TYPES.BANK_ACCOUNT_UPDATE_FAILED:
      reportFunctionError({
        domain: 'dashboard',
        message: 'Failed to update bank account (API Call)',
        name: 'updateBankAccount',
        exception: payload,
        parentName: 'BankAccount',
      });
      return update(state, {
        $merge: {
          error: payload.response.data,
          loading: false,
        },
      });

    default:
      return state;
  }
};
